import { render, staticRenderFns } from "./AnexoGomez.vue?vue&type=template&id=78943106&scoped=true&"
import script from "./AnexoGomez.vue?vue&type=script&lang=js&"
export * from "./AnexoGomez.vue?vue&type=script&lang=js&"
import style0 from "./AnexoGomez.vue?vue&type=style&index=0&id=78943106&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78943106",
  null
  
)

export default component.exports